import { httpsCallable } from 'firebase/functions';
import { functions } from '../constants/firebaseModular';
import type {
  RequestBetaAccessRequest,
  RequestBetaAccessResponse,
} from '@usacsmideo/types';

/**
 * Requests access to a beta feature for the authenticated patient. Thin wrapper
 * over the `requestBetaAccess` callable (server records the request under the
 * caller's UID and notifies the concierge). Throws on failure so callers can
 * surface an inline error. (CU-86aj8k2b9)
 */
export const requestBetaAccess = async (
  payload: RequestBetaAccessRequest,
): Promise<RequestBetaAccessResponse> => {
  const call = httpsCallable<RequestBetaAccessRequest, RequestBetaAccessResponse>(
    functions,
    'requestBetaAccess',
  );
  const res = await call(payload);
  return res.data;
};
